import { render, staticRenderFns } from "./Wp_home_module_webview.vue?vue&type=template&id=52da69ea&scoped=true&"
import script from "./Wp_home_module_webview.vue?vue&type=script&lang=js&"
export * from "./Wp_home_module_webview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da69ea",
  null
  
)

export default component.exports